export const MM_DD_YYYY = new RegExp(/^(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/]\d{4}$/);
export const EMAIL = new RegExp(/\S+@\S+\.\S+/);
export const PHONE_NUMBER = new RegExp(/^([0-9]|x)+$/);
export const NDC = new RegExp(/^(?<labelerCode>[0-9]{4,5})-(?<productCode>[0-9]{3,4})-(?<packageSize>[0-9]{1,2})$/);
export const NDC_11_DIGIT_BILLING = new RegExp(
  /^(?<labelerCode>[0-9]{5})(?<productCode>[0-9]{4})(?<packageSize>[0-9]{2})$/
);
export const POSITIVE_INTEGER = new RegExp(/^\d+$/);
export const POSITIVE_FLOAT = new RegExp(/^\d+(\.\d+)?$/);
